import commonRouters from '@/router/routers/client/common'
import detailRouters from '@/router/routers/client/detail'

const clientRouter = (beforeEnter, name, singleName, basePath, tabs, onlyManaged, options) => {
    return [
        ...commonRouters(beforeEnter, name, singleName, basePath, tabs, onlyManaged, options),
        ...detailRouters(beforeEnter, name, singleName, basePath, tabs, onlyManaged, options)
    ]
}

export default clientRouter
